import React, { useCallback, useState, useContext, useEffect, useMemo } from "react"
import Footer from "./footer"
import '../scss/locomotive-scroll.scss'
import "../scss/site.scss"
import SmoothScroll from "./loadableScroll"
import Contact from "./contact"
import { ScrollContext } from "../context/scrollContext"
import Cursor from '../components/cursor'
import Link from './link'
import VideoPlayer from "./videoPlayer"
import { useInView } from "react-intersection-observer"


const LayoutContent = ({ optimised, children, update, footer }) => {
  return (
    <>
      <ScrollContainer footer={footer} update={update} optimised={optimised} >
        {children}
      </ScrollContainer>
    </>
  )
}

const Layout = ({ children, optimised, footer }) => {
  const scroll = useContext(ScrollContext)

  const update = useMemo(() => {
    if (scroll) {
      return scroll?.scrollActions?.update
    } else {
      return () => { }
    }
  }, [scroll])

  return (
    <LayoutContent update={update} footer={footer} optimised={optimised}>
      {children}
    </LayoutContent >
  )
}

const ScrollContainer = ({ children, optimised, footer, update }) => {

  const [height, setHeight] = useState(0)

  const heightMVH = useCallback((height) => {
    const restHeight = window.innerHeight - height
    return `${restHeight}px`
  }, [])

  const carsouel = useCallback((node) => {
    if (node !== null) {
      setTimeout(() => {
        setHeight(heightMVH(node.clientHeight))
      }, 0)
    }
  }, [setHeight, heightMVH])

  useEffect(() => {
    if (height !== `0px`) {
      setTimeout(() => {
        update()
      }, 0)
    }
  }, [update, height])

  const showCursor = () => {

    document.querySelector('.floating--cursor').classList.add('active');
  }

  const hideCursor = () => {

    document.querySelector('.floating--cursor').classList.remove('active');
  }

  const { ref } = useInView({ threshold: 0 })

  if (footer) {
    return (
      <>
        <SmoothScroll className='z-10 pos-rel'>
          <main className='will--blur'>
            {children}
            <Footer ref={carsouel} optimised={optimised} />
          </main>
        </SmoothScroll>
      </>
    )
  } else {
    return (
      <>


        <div style={{ height: '100vh' }} className="pos-fixed z-0 top-0 h-100 w-100 video-wrapper filter-75">
          <VideoPlayer url='https://player.vimeo.com/progressive_redirect/playback/710602801/rendition/1080p/file.mp4?loc=external&signature=3f1c9fdd8b92761e045cd839f3e3d93ca340ae80db6e4c9b348b7c66a913a731' />
        </div>
        <Cursor />


        <SmoothScroll className='z-10 pos-rel'>
          <main className='will--blur'>
            {children}
          </main>

          <div ref={ref} data-scroll-class='inview' style={{ height: 'calc(100vh - 50px)' }} className=" border-box grid grid-rows-3 gap-0" data-scroll data-scroll-offset='50%' data-scroll-repeat='true'  >
            <div />
            <div role='presentation' onMouseEnter={() => showCursor()} onMouseLeave={() => hideCursor()} className="flex justify-c text-white text-center align-center">
              <div>
                <Link className='link' to='/contact'>
                  <p className='h1 xs flip-text--container'>
                    Ready to<br />
                    talk<br />
                    <span className='flip--text'>
                      <span className='first'>Business?</span>
                      <span className='second'>Pleasure?</span>
                    </span>
                  </p>
                </Link>
              </div>
            </div>
            <Contact onMouseEnter={() => hideCursor()} />
          </div>
        </SmoothScroll>
      </>
    )
  }
}



export default Layout
